enum StagesEnum {
  REGISTRATIONS = 'REGISTRATIONS',
  DETAILED_SHEETS = 'DETAILED_SHEETS',
  ASSEMBLIES = 'ASSEMBLIES',
  ACCESS_ORDERS = 'ACCESS_ORDERS',
}

export default StagesEnum;
